import React from "react";
import EmailTemplateForm from "./EmailTemplateForm";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { Resolver, useForm } from "react-hook-form";
import { IEmailTemplate } from "../../../shared/interfaces/email-template/IEmailTemplate";
import { AdminEmailTemplateService } from "../service";
import { enqueueSnackbar } from "notistack";
import { handleError } from "../../../shared/functions/handleError";
import * as yup from "yup";
import { ELanguage } from "../../../shared/enums/user/ELanguage";
import { EEmailCategory } from "../../../shared/interfaces/email-list/IEmailList";

export const emailTemplateForm = yup.object({
  name: yup.string().required("validation.required"),
  subject: yup.string().required("validation.required"),
  content: yup.string().required("validation.required"),
  active: yup.boolean().required("validation.required"),
  language: yup
    .mixed<ELanguage>()
    .oneOf(Object.values(ELanguage))
    .required("validation.required"),
  category: yup
    .mixed<EEmailCategory>()
    .oneOf(Object.values(EEmailCategory))
    .required("validation.required"),
});

const EmailTemplateCreate = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { handleSubmit, control } = useForm<IEmailTemplate>({
    resolver: yupResolver(
      emailTemplateForm,
    ) as unknown as Resolver<IEmailTemplate>,
    defaultValues: {
      active: false,
    },
  });

  const submitHandler = (formData: IEmailTemplate) => {
    AdminEmailTemplateService.create(formData)
      .then((response) => {
        if (response) {
          navigate(-1);
          enqueueSnackbar(
            t("toasts.successfullyCreated", { title: formData?.name }),
            {
              variant: "success",
            },
          );
        }
      })
      .catch(handleError);
  };

  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <EmailTemplateForm control={control} />
    </form>
  );
};
export default EmailTemplateCreate;
